import { useEffect } from 'react';
import * as React from 'react';

import useScript, { Status } from '@/hooks/useScript';
interface FingerprintProps {
  setState: React.Dispatch<React.SetStateAction<string>>;
}

const Fingerprint: React.FC<FingerprintProps> = ({ setState }) => {
  const ssStatus = useScript('/fingerprint/sha.js');
  const dfpStatus = useScript('/fingerprint/devicefingerprint.js');
  const cStatus = useScript('/fingerprint/client.min.js');
  const fpStatus = useScript('/fingerprint/fingerprint2.js');

  const getUserDevice = (): string | Object => {
    const userDevice = (
      document.getElementById('user_device') as HTMLInputElement
    )?.value;
    return userDevice && JSON.parse(userDevice);
  };

  useEffect(() => {
    if (
      [ssStatus, dfpStatus, cStatus, fpStatus].every(
        status => status === Status.Ready,
      ) &&
      window.getFingerPrint !== undefined
    ) {
      try {
        window.getFingerPrint();
        const userDevice = getUserDevice();
        setState(JSON.stringify(userDevice));
      } catch (e) {
        throw new Error(e as string);
      }
    }
  }, [ssStatus, dfpStatus, cStatus, fpStatus]);

  return <input id="user_device" type="hidden" name="user_device" />;
};

export default Fingerprint;
